import { Card, Row, Col } from 'react-bootstrap';
import { useRef } from 'react';
import ReadOnlyCaresProgramOptions from './ReadOnlyCaresProgramOptions';
import ReadOnlyCalculatedBenefits from './ReadOnlyCalculatedBenefits';
import CurrencyField from '../../../benefit/fields/CurrencyField';

const ModifyCaresBenefit = ({ benefit, incomeMeasurementType, incomeMeasurementPercentage, arrearsLiabilityAmount, onArrearsLiabilityAmountChange, pledgeAmount, isSubmitting }) => {
  const originalArrearsRef = useRef(benefit.arrearsLiabilityAmount);
  const originalPledgeRef = useRef(benefit.pledgeAmount);

  return (
    <>
      {!!originalArrearsRef.current &&
        <Row className="mt-3">
          <h4>Correct Arrears Liability Amount</h4>
          <Col md={6}>
            <CurrencyField
                value={arrearsLiabilityAmount}
                fieldName="Arrears Liability Amount"
                onChange={onArrearsLiabilityAmountChange}
                isSubmitting={isSubmitting}
                required
            />
          </Col>

          <Col>
            <CurrencyField
                value={pledgeAmount}
                fieldName="Calculated Pledge Amount"
                isSubmitting={isSubmitting}
                disabled
            />
          </Col>
        </Row>
      }
      <Row className="mt-3">
        <Col>
          <ReadOnlyCalculatedBenefits
            arrearsLiabilityAmount={arrearsLiabilityAmount}
            originalArrears={originalArrearsRef.current}
            incomeMeasurementType={incomeMeasurementType}
            incomeMeasurementPercentage={incomeMeasurementPercentage}
            arrearage={benefit.arrearage}
            energyDiscount={benefit.energyDiscount}
            pledgeAmount={pledgeAmount}
            referralSource={benefit.referralSource}
            originalPledgeAmount={originalPledgeRef.current}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <ReadOnlyCaresProgramOptions
            tpaFlg={benefit.tpaFlg}
            tpaMonths={benefit.tpaMonths}
            tpaMonthlyInstallmentEst={benefit.tpaMonthlyInstallmentEst}
            weatherizationProgramInterest={benefit.weatherizationProgramInterest}
            referralSource={benefit.referralSource}
          />
        </Col>
      </Row>
      
      {!originalArrearsRef.current &&
        <Card border="info" className="mt-3">
          <Card.Header className="bg-secondary-soft">
            <strong>CARES Notice</strong>
          </Card.Header>
          <Card.Body>
            Corrections are not possible on CARES benefits at this time because Customer data is not accessible from Audit Report. If something is incorrect, you must reject this benefit and ask the agency to resubmit with the correct information, or recreate the benefit on behalf of the agency.
          </Card.Body>
        </Card>
      }
    </>
  );
};

export default ModifyCaresBenefit;